export const pathMatcher = (pathname, transactions = []) => {
  let result = ''
  if (pathname.includes('home')) {
    pathname = '/home'
  }
  const pathTab = pathname.split('/')
  for (let i = 0; i < pathTab.length; i++) {
    if (pathTab[i].length > 0) {
      result += pathTab[i] + ' - '
    }
  }
  result = result.charAt(0) + result.slice(1)
  result = result.slice(0, -3)
  switch (result) {
    case 'home':
      return 'Home'
    case 'lockers':
      return 'Casiers'
    case 'customers':
      return 'Clients'
    case 'history':
      return 'Historique'
    case 'products':
      return 'Produits'
    default:
      return result.charAt(0).toUpperCase() + result.slice(1)
  }
}

export const getHeaderTitle = (path, transactions = []) => {
  const pathTab = path.split('/')
  if (pathTab.length === 2) {
    switch (pathTab[1]) {
      case 'home':
        return 'Home'
      case 'lockers':
        return 'Casiers'
      case 'customers':
        return 'Clients'
      case 'history':
        return 'Historique'
      case 'products':
        return 'Produits'
      default:
        return 'No Title'
    }
  } else if (pathTab.length === 3) {
    let currentTransaction
    switch (pathTab[1]) {
      case 'home':
        return 'Home'
      case 'table':
        currentTransaction = transactions.find(
          t => t.pool && t.pool.table && t.pool.table.key === pathTab[2]
        )
        if (currentTransaction) {
          return currentTransaction.pool.table.name
        }
        return 'No Title'
      case 'bar':
        currentTransaction = transactions.find(
          t => t.bar && t.bar.key && t.bar.key === pathTab[2]
        )
        if (currentTransaction) {
          return currentTransaction.bar.name
        }
        return 'No Title'
      default:
        return 'No Title'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/pathMatcher.js